/* eslint-disable no-param-reassign */
import { find, each, isObject } from 'lodash';

const findElement = (labels, topElem, key) => {
  const elem = find(labels,
    l => l.getAttribute('for') === key)
    || document.getElementsByName(key)[0];
  if (elem && elem.getBoundingClientRect().top <= topElem.getBoundingClientRect().top) {
    return elem;
  }
  return topElem;
};

const getPath = (path, key) => {
  if (path) {
    return `${path}.${key}`;
  }
  return key;
};
/**
 * Convert a JSON object into a flattened name value pairs structure.
 * e.g.
 * {
 *    food: {
 *      fish: 'snapper',
 *      vegetable: 'green peeper'
 *    }
 * }
 *
 * Becomes:
 * food.fish: 'hoki'
 * food.vegetable: 'green peeper'
 */
const flatten = (obj, result, path) => {
  each(obj, (val, key) => {
    if (!isObject(val)) {
      result[getPath(path, key)] = val;
    } else {
      flatten(val, result, getPath(path, key));
    }
  });
  return result;
};

const handleSubmitFail = (errs) => {
  const labels = document.getElementsByTagName('label');
  let topElem = document.getElementById('submit-checkout-button');
  each(flatten(errs, {}, ''), (val, key) => {
    topElem = findElement(labels, topElem, key);
  });
  topElem.scrollIntoView({ block: 'start', behavior: 'smooth' });
};

export default handleSubmitFail;



/** WEBPACK FOOTER **
 ** ./src/components/checkout/SubmitFailHandler.js
 **/